import { render, staticRenderFns } from "./tenderos.vue?vue&type=template&id=0cfd3875&"
import script from "./tenderos.vue?vue&type=script&lang=js&"
export * from "./tenderos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports